import React from 'react';
import classes from './AdminMenu.module.scss';
import { NavLink } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import { useAppSelector } from '../../../store/hooks';

const AdminMenu: React.FC = () => {
  const user = useAppSelector(state => state.auth.user);

  return (
    <Container>
      <Row>
        <Col>
          <div className={[classes['admin-menu']].join(' ')}>
            <NavLink to='loads'
              className={({ isActive, isPending }) => isPending ?
                classes.pending : isActive ? classes.active : ""}
            >Loads</NavLink>

            <NavLink to='prices'
              className={({ isActive, isPending }) => isPending ?
                classes.pending : isActive ? classes.active : ""}
            >Price Lists</NavLink>

            <NavLink to='users'
              className={({ isActive, isPending }) => isPending ?
                classes.pending : isActive ? classes.active : ""}
            >Users</NavLink>

            {user?.userType === 'owner' && (
              <NavLink to='settings'
                className={({ isActive, isPending }) => isPending ?
                  classes.pending : isActive ? classes.active : ""}
              >Company</NavLink>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminMenu;
